'use client'

import { createContext, Dispatch, ReactNode, SetStateAction, useState } from 'react'
import { OrderNavigation } from '@/app/[locale]/(shop)/order-navigation'
import { Basket } from '@/app/[locale]/(basket)/basket'
import { Customer, CustomerAddress, CustomerLocation } from '@/types/customers'
import { ContactPerson } from '@/types/orders'
import { getNextAvailablePickupDate } from '@/lib/pickup-date'
import { useTranslations } from 'next-intl'

export const OrderContext = createContext<{
  customer?: Customer
  address?: CustomerAddress
  location?: CustomerLocation
  driverMessage: string
  pickupDate?: Date
  contactPerson?: Partial<ContactPerson>
  validationErrors: Record<string, string>
  setCustomer: (customer?: Customer) => void
  setAddress: (address?: CustomerAddress) => void
  setLocation: (location?: CustomerLocation) => void
  setContactPerson: Dispatch<SetStateAction<Partial<ContactPerson> | undefined>>
  setPickupDate: (date: Date) => void
  setDriverMessage: (message: string) => void
  setValidationErrors: (errors: Record<string, string>) => void
}>({} as any)

export const OrderPage = ({ withPayment, children }: { withPayment?: 'invoice' | 'nets'; children: ReactNode }) => {
  const t = useTranslations()
  const [customer, setCustomer] = useState<Customer>()
  const [address, setAddress] = useState<CustomerAddress>()
  const [location, setLocation] = useState<CustomerLocation>()
  const [driverMessage, setDriverMessage] = useState('')
  const [pickupDate, setPickupDate] = useState<Date>(() => getNextAvailablePickupDate(new Date()))
  const [contactPerson, setContactPerson] = useState<Partial<ContactPerson>>()
  const [validationErrors, setValidationErrors] = useState({})

  const orderContext = {
    customer,
    address,
    location,
    driverMessage,
    pickupDate,
    contactPerson,
    validationErrors,
    setCustomer,
    setAddress,
    setLocation,
    setContactPerson,
    setPickupDate,
    setDriverMessage,
    setValidationErrors,
  }

  return (
    <OrderContext.Provider value={orderContext}>
      <div className="mx-auto my-12 w-full max-w-screen-xl px-8 md:my-16">
        <OrderNavigation />
        <div className="mt-10 grid w-full grid-cols-1 gap-8 lg:grid-cols-[1fr_400px] lg:items-start">
          {children}
          <div>
            <h3 className="mb-10 block text-2xl font-semibold">{t('Shopping_cart')}</h3>
            <Basket withPayment={withPayment} />
          </div>
        </div>
      </div>
    </OrderContext.Provider>
  )
}
